/* eslint-disable max-len, import/export, no-use-before-define */
export default function mixins(...args) {
  return ({
    mixins: args
  });
}
//# sourceMappingURL=mixins.js.map